export default "__VITE_ASSET__BH$GA1GY__"